import React, { Component } from 'react'
import { connect } from 'react-redux'
import { CSSTransition } from 'react-transition-group'
import { 
  getTranslation, 
  getPageOrderOpened, 
  getToken, 
  getPages, 
  getTotalPages,
  getActualPage,
  getLastPagePosition,
  getActualPageIndex
} from '@/store/getters'
import {   
  setPagesOrder,
  setPages,
  setActivePage,
  setElements,
  batchPagesUpdate,
  togglePageOrder,
  clonePage,
  updatePage,
  showAlert,
  closeAlert,
  removePage,
  setActiveElement,
  toggleToaster
} from '@/store/actions'
import { MagazineConsumer } from '@/contexts/magazine'
import { withDragAndDrop } from '@/hocs/withDragAndDrop'

import styles from './styles.scss'

/** Components */
import Thumbnail from '@/components/Thumbnail'
import IconComponent from '@/components/commons/IconComponent'
import { PopOver } from '@/components/commons/PopOver'

class PageOrder extends Component {
  static contextType = MagazineConsumer;

  constructor(props){
    super(props)
    this.wrapperPageOrderRef = React.createRef()
  }

  handleAdd = () => {
    const { setActiveElement, toggleToaster, translation } = this.props
    const { onAddPage } = this.context

    setActiveElement(null)
    toggleToaster({
      isVisible: true,
      message: translation('page-add-toast-message'),
      position: 'top-right',
      type: 'success'
    })
    onAddPage()
  }

  onDragEnd = () => {
    const { dragCallbacks } = this.props
    const data = dragCallbacks.getDragData()
    if ( !data ) {
      dragCallbacks.onDragEnd()
      return
    }
    const { dragData, dropData } = data
    
    this.updatePagesOrder( dropData.index, dragData.index )
    this.swapPages( dropData.index, dragData.index, dragData.page_id )
  }

  swapPages ( from, to, activeID ) {
    const { pages, setPages } = this.props
    const toSwap = pages[from]
    pages[from] = pages[to]
    pages[to] = toSwap
    setPages( pages )

    const page = pages.filter( p => +p.id === +activeID )[0]
    if ( page ) {
      this.props.setActivePage( page )
      this.props.setElements( page.items )
    }
  }

  updatePagesOrder ( from, to ) {
    const { pages, batchPagesUpdate, token } = this.props
    const toSwap = pages[to]
    const fromSwap = pages[from]
    const oldIndex = toSwap.page_position

    if ( oldIndex === fromSwap.page_position ) {
      fromSwap.page_position = oldIndex + 1
    } else {
      toSwap.page_position = fromSwap.page_position
      fromSwap.page_position = oldIndex
    }
    batchPagesUpdate( {
      pages: [ toSwap, fromSwap ],
      token: token
    } )
  }
  
  handleEdit = () => {
    const { togglePageOrder } = this.props

    togglePageOrder( {
      isOpened: false
    } )
  }

  handleDuplicate = (pageId) => {
    const {
      lastPagePosition: page_position,
      translation,
      clonePage,
      showAlert,
      closeAlert,
      toggleToaster,
      setActiveElement
    } = this.props

    const { id } = pageId

    showAlert({
      title: translation('pages-duplicate-title'),
      message: translation('pages-duplicate-message'),
      hasCancel: true,
      type: 'alert',
      callback: () => {
        setActiveElement(null)
        clonePage(id, { page_position })
        closeAlert()

        toggleToaster({
          isVisible: true,
          message: translation('page-duplicate-toast-message'),
          position: 'top-right',
          type: 'success'
        })
      }
    })
  }

  handleDelete = (pageId) => {
    const {
      translation,
      removePage,
      showAlert,
      closeAlert,
      toggleToaster,
      setActiveElement
    } = this.props

    const { id } = pageId

    showAlert({
      title: translation('pages-remove-title'),
      message: translation('general-delete-message'),
      hasCancel: true,
      type: 'error',
      callback: () => {
        setActiveElement(null)
        removePage(id)
        closeAlert()
        toggleToaster({
          isVisible: true,
          message: translation('page-removed-toast-message'),
          position: 'top-right',
          type: 'error'
        })
      }
    })
  }
    
  render () {
    const { translation, togglePageOrder, pageOrderOpened, dragCallbacks, pages, totalPages, actualPageIndex } = this.props
    const { isOpened } = pageOrderOpened

    const shapeOption = ( isOpened)
      ? styles['wrapper-page-order__active']
      : ''

    return (
      <CSSTransition
        in={( isOpened )}
        timeout={300}
        classNames="slide-left"
        unmountOnExit
      >
        <PopOver 
          className={`${styles['wrapper-page-order']} ${shapeOption}`}
          hidePopover={() => 
            togglePageOrder( {
              isOpened: false
            } )
          }
        >
          <div className={styles['wrapper-page-order__title']}>
            <h1>{ translation( 'general-page-order' )}</h1>
            <button
              onClick={() =>
                togglePageOrder( {
                  isOpened: false
                } )
              }
            >
              <IconComponent icon="cancel" />
            </button>
          </div>
          <div className={`${styles['wrapper-page-order__pages']} ${ totalPages%2 ? styles['wrapper-page-order__pages-last'] : '' }`} ref={this.wrapperPageOrderRef}>
            {pages.map( ( page, index ) => (
              <Thumbnail
                wrapperPageOrderRef={this.wrapperPageOrderRef}
                item={page}
                index={index}
                length={pages.length}
                key={page.id}
                page_id={page.id}
                selected={actualPageIndex}
                items={page.items}
                dragCallbacks={dragCallbacks}
                onDragEnd={this.onDragEnd}   
                handleEdit={this.handleEdit}
                handleDuplicate={() => this.handleDuplicate(page)}
                handleDelete={() => this.handleDelete(page)}         />
            ) )}
            
          </div>
          {/* <button className='ba-btn ba-btn-normal ba-sm ba-rounded' onClick={this.handleAdd}>
            <builderall-icon code='22b9'></builderall-icon>
          </button> */}
          
        </PopOver>
      </CSSTransition>
    )
  }
}

const mapStateToProps = state => {
  const translation = getTranslation( state )
  const pageOrderOpened = getPageOrderOpened( state )
  const token = getToken( state )
  const pages = getPages( state )
  const totalPages = getTotalPages( state )
  const actualPage = getActualPage(state)
  const lastPagePosition = getLastPagePosition(state)
  const actualPageIndex = getActualPageIndex(state)
  return { translation, pageOrderOpened, token, pages, totalPages, actualPage, lastPagePosition, actualPageIndex }
}

export default withDragAndDrop( connect(
  mapStateToProps,
  { 
    setPagesOrder,
    setPages,
    setActivePage,
    setElements,
    batchPagesUpdate,
    togglePageOrder,
    setActiveElement,
    toggleToaster,
    clonePage,
    updatePage,
    showAlert,
    closeAlert,
    removePage,
  }
)( PageOrder )
)



// WEBPACK FOOTER //
// ./src/pages/Editor/components/PageOrder/index.js